import React, { useRef } from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { products } from '../../data/products';
import { getCreator, isProductLeavingSoon } from '../../utils/catalog';
import { ProductCard } from '../product/ProductCard';
import { SectionHeading } from '../ui/SectionHeading';
export function LastDaysCarousel() {
  const trackRef = useRef<HTMLUListElement>(null);
  const leaving = products.filter(isProductLeavingSoon).sort((a, b) => (getCreator(a.creatorId)?.exhibitionEnd ?? '').localeCompare(getCreator(b.creatorId)?.exhibitionEnd ?? ''));
  if (leaving.length === 0) return null;
  const scroll = (dir: 1 | -1) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({
      left: dir * el.clientWidth * 0.8,
      behavior: 'smooth'
    });
  };
  return <section className="bg-shell py-16 md:py-24" aria-labelledby="derniers-jours-title" data-id="element-329" data-mp="2df1j15tybmz5">
      <div className="mx-auto max-w-[1440px] px-5 md:px-8" data-id="element-330" data-mp="2hgczakqxqvuo">
        <SectionHeading id="derniers-jours-title" title={<>
              Derniers jours <em className="text-clay" data-id="element-332" data-mp="1pb4lilvavaiy">en vitrine</em>
            </>} description="Ces créateurs quittent la boutique d’ici trois semaines. Ensuite, leurs pièces repartent avec eux." link={{
        to: '/boutique?derniers=1',
        label: 'Tout voir'
      }} data-id="element-331" data-mp="1u9zbc7ropzck" />
        <div className="relative" data-id="element-333" data-mp="1fj8hyvag2s7c">
          <ul ref={trackRef} className="no-scrollbar -mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-px-5 px-5 md:mx-0 md:gap-6 md:px-0" data-id="element-334" data-mp="1am8comlf5tha">
            {leaving.map(p => <li key={p.id} className="w-[68%] shrink-0 snap-start sm:w-[42%] lg:w-[calc(25%-18px)]" data-id="element-335" data-mp="11m39kon9dh8x">
                <ProductCard product={p} data-id="element-336" data-mp="wnrxs8dekwo2" />
              </li>)}
          </ul>
          <div className="mt-6 hidden justify-end gap-2 md:flex" data-id="element-337" data-mp="2vy03qpd3517o">
            <button type="button" onClick={() => scroll(-1)} aria-label="Précédent" className="flex h-11 w-11 items-center justify-center rounded-full border border-ink/20 transition-colors duration-150 hover:border-ink" data-id="element-338" data-mp="2qzq70abppsjy">
              <ArrowLeftIcon className="h-4 w-4" data-id="element-339" data-mp="fd4tylrsyocq" />
            </button>
            <button type="button" onClick={() => scroll(1)} aria-label="Suivant" className="flex h-11 w-11 items-center justify-center rounded-full border border-ink/20 transition-colors duration-150 hover:border-ink" data-id="element-340" data-mp="fas3tlbw57ol">
              <ArrowRightIcon className="h-4 w-4" data-id="element-341" data-mp="1czvdr4mdgqzf" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}